export default __webpack_public_path__ + "assets/icons/wechat.782fec86.svg";